import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CustomPagination from '../../components/company_panel/common/custompagination'
import { capitalizeFirstLetter, checkPermission, formateDate, getBrandId, getOutletBusinessDate, getOutletId, isOnline, removeHyphens, TrimText, getExcelColumnWidths } from '../../helpers/commonFunctions';
import { GetBrandOutletsList } from '../../services/company_panel/outletService';
import Sorting from '../../components/company_panel/common/sorting';
import Loader from '../../components/company_panel/common/loader'
import StatusFilter from '../../components/company_panel/common/statusFilter'
import { LOADER_TIME, showFilterlist } from '../../utils/Constants'
import CustomRangepicker from '../../components/company_panel/common/rangepicker'
import $ from "jquery";
import { getCompany } from '../../helpers/commonFunctions';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import notFound from '../../assets/company/img/no-record-found.png'
import { ListCustomer } from '../../services/company_panel/customer.services';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ListRefund } from '../../services/company_panel/refund.services';
import QRCode from "react-qr-code";
import { Modal, Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { GetSingleOrderDetails, reportToZatcaAgain } from '../../services/company_panel/orderService';
import { GetCustomerInvoice } from '../../services/company_panel/setting/invoiceServices';
import { renderReceiptCanvas, canvasToPdf } from '../../helpers/receiptTemplate';
import GlobalLoader from '../../components/company_panel/common/globalLoader';
import { usePersistedListState } from '../../hooks/usePersistedListState';


const RefundList = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()
    // persisted filters (page lives in the route) — restored on return from view
    const { saved, save, clear } = usePersistedListState('refunds');
    const [list, setList] = useState([])
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(saved?.itemPerPage || 10)
    const [sorting, setSorting] = useState(saved?.sorting || {});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(Number(params?.id) || 1);
    const [loader, setLoader] = useState(true)
     const [globalLoader, setGlobalLoader] = useState(false);
    const [invoicePreview, setInvoicePreview] = useState({ open: false, image: '', order: null });
    const invoiceCanvasRef = useRef(null);
    const [search, setSearch] = useState(saved?.search || {})
    const [globalSearch, setGlobalSearch] = useState(saved?.globalSearch || "")
    const [resetdate, setResetDate] = useState(false);
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);
    const [showZatcaDetailsModel, setShowZatcaDetailsModel] = useState(false);
    const [loaderNew, setLoaderNew] = useState(false)
    const [zatcaModelData, setZatcaModelData] = useState([]);

    const businessDate =  getOutletBusinessDate();
    const start_date = new Date(businessDate.setHours(0,0,0,0));
    const end_date = new Date(businessDate.setHours(23,59,59,999));
    // console.log(businessDate);
    // if we're returning with a persisted date filter, show that range in the picker
    // instead of the default business date (records already restore from saved.search)
    const [defaultDateFilter, setDefaultDateFilter] = useState(
        saved?.search?.created
            ? [new Date(saved.search.created.start), new Date(saved.search.created.end)]
            : [start_date, end_date]
    );
    const defaultDateFilterRef = useRef({
        start_date,
        end_date
    });
    

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
             setSearch({});
                            
            const businessDate =  getOutletBusinessDate();
            const start_date = new Date(businessDate.setHours(0,0,0,0));
            const end_date = new Date(businessDate.setHours(23,59,59,999));
            setDefaultDateFilter([
                start_date,
                end_date
            ])
            defaultDateFilterRef.current = {
                start_date,
                end_date
            }
            
            setIsOutletChanged(!isOutletChanged);
        });
    });

    useEffect(() => {
        if (search) {
            setLoader(true)
            setTimeout(() => {
                const formData = new FormData()

                let modifiedSearchFilter= search;
                if(!search || !search.created){
                    modifiedSearchFilter = {
                        ...(search ? search : {}),
                        created: {
                            start: defaultDateFilterRef.current?.start_date.toISOString(),
                            end: defaultDateFilterRef.current?.end_date.toISOString()
                        }
                    }
                }
                formData.append("search", JSON.stringify(modifiedSearchFilter))

                formData.append("page", page)
                formData.append("per_page", itemPerPage)
                formData.append("sort", JSON.stringify(sorting))
                formData.append("global_search", globalSearch)
                formData.append('outlet_id', getOutletId());
                ListRefund(formData).then(data => {
                    setDataLength(data.data.response.count);
                    setList(data && data.data && data.data.response ? data.data.response.rows : [])
                    setLoader(false);
                }).catch(error => {
                    console.log("error ====> ", error);
                    setLoader(false);
                })
            }, 500);
        }
    }, [location, statsUpdate, sorting, search, globalSearch, isBrandChanged, isOutletChanged, defaultDateFilter])

    // persist filters on every change (page lives in the route, not the store)
    useEffect(() => {
        save({ itemPerPage, sorting, search, globalSearch });
    }, [itemPerPage, sorting, search, globalSearch])

    // On company panel reload, fetch the outlet's current business date once (it can change from other panels)
    useEffect(() => {
        if (!isOnline()) return;
        GetBrandOutletsList({ brand_ids: JSON.stringify([getBrandId()]) }).then(data => {
            const outlets = data?.data?.response || [];
            const currentOutlet = outlets.find(o => Number(o.id) === Number(getOutletId()));
            if (currentOutlet?.business_date) {
                localStorage.setItem('outlet_business_date', currentOutlet.business_date);
                const start_date = new Date(new Date(currentOutlet.business_date).setHours(0, 0, 0, 0));
                const end_date = new Date(new Date(currentOutlet.business_date).setHours(23, 59, 59, 999));
                defaultDateFilterRef.current = { start_date, end_date };
                // don't clobber the picker if we restored a persisted date filter
                if (!saved?.search?.created) {
                    setDefaultDateFilter([start_date, end_date]);
                }
            }
        }).catch(error => {
            console.log("business date error ====> ", error);
        });
    }, []);


    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        setDefaultDateFilter([defaultDateFilterRef.current.start_date, defaultDateFilterRef.current.end_date])
        clear()
    }

    const viewFunction = (row) => {
        navigate(`/company/transaction/refund/view/${row}?pageno=${page}`)
    }

    const printFunction = async (id) => {
        setGlobalLoader(true);
        try {
            const brand_id = getBrandId();
            const [orderRes, invoiceRes] = await Promise.all([
                GetSingleOrderDetails({ id, brand_id }),
                GetCustomerInvoice({ brand_id }).catch(() => null),
            ]);
            const orderDetails = orderRes?.data?.response;
            if (!orderDetails) {
                throw new Error('Order details not found');
            }
            const invoiceSettings = invoiceRes?.data?.response || {};
            const canvas = await renderReceiptCanvas(orderDetails, invoiceSettings);
            invoiceCanvasRef.current = canvas;
            setInvoicePreview({ open: true, image: canvas.toDataURL('image/png'), order: orderDetails });
            setGlobalLoader(false);
        } catch (error) {
            setGlobalLoader(false);
            console.log('Generate invoice error ====> ', error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.message || 'Could not generate the invoice.',
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            });
        }
    };

    const handleDownloadInvoice = () => {
        if (invoiceCanvasRef.current) {
            canvasToPdf(invoiceCanvasRef.current, invoicePreview.order);
        }
    };

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }

    const headerMapping = {
        "id": "Order ID",
        "order_mode": "Order Mode",
        "aggregator": "Aggregator",
        "outlet_name": "Outlet Name",
        "customer_name": "Customer Name",
        "order_amount": "Order Amount",
        "refunded_amount": "Refunded Amount",
        "refund_reason": "Reason For Refund",
        "payment_status": "Payment Status",
        "ordered_by": "Ordered By",
        "refunded_at": "Refunded At",
        "business_date": "Business Date"
    };

    const formatValue = (value) => {
        if (value === null || value === undefined || value === "") {
            return 'N/A';
        }
        return value.toString().replace(/_/g, ' ');
    };

    const handleExport = () => {
        setGlobalLoader(true);
        const formData = new FormData()
        formData.append("page", 1)
        formData.append("per_page", dataLength)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('outlet_id', getOutletId());
        ListRefund(formData).then(data => {
            const listData = data && data.data && data.data.response ? data.data.response.rows : [];
            const printData = listData.map((item) => {
                const transformedItem = {};
                // Extract fields from nested objects
                const orderID = item.id || 'N/A';
                const orderMode = item.order_mode_configuration?.name || 'N/A';
                const aggregatorName = item.aggregators_configuration?.name || 'N/A';
                const outletName = item.outlet?.outlet_name || 'N/A';
                const customerName = item.customer?.customer_name || 'N/A';
                const orderAmount = item.transaction?.amount || 'N/A';
                const refundedAmount = item.transaction?.refunded_amount || "N/A";
                const refundReason = item.transaction?.refundReason?.reason || 'N/A';
                const paymentStatus = item?.transaction?.payment_status
                    ?
                        item?.transaction?.payment_status != 'refunded'
                        ?   capitalizeFirstLetter(item?.transaction?.payment_status)
                        :   item?.transaction?.refundReason?.type_of_refund == 'full' ? 'Refunded' : 'Partial Refunded'
                    : "N/A"
                const refundedAt = new Date(item.transaction?.refunded_time).toLocaleString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                }).replace(',', '');
                const orderedBy = item.order_source == 'online' ? 'Online' : `${item.user?.first_name} ${item.user?.last_name}`;

                // Map fields according to headerMapping
                for (const key in headerMapping) {
                    if (headerMapping.hasOwnProperty(key)) {
                        const newKey = headerMapping[key];
                        switch (key) {
                            case "id":
                                transformedItem[newKey] = orderID;
                                break;
                            case "order_mode":
                                transformedItem[newKey] = capitalizeFirstLetter(removeHyphens(orderMode));
                                break;
                            case "aggregator":
                                transformedItem[newKey] = capitalizeFirstLetter(removeHyphens(aggregatorName));
                                break;
                            case "outlet_name":
                                transformedItem[newKey] = capitalizeFirstLetter(outletName);
                                break;
                            case "customer_name":
                                transformedItem[newKey] = capitalizeFirstLetter(customerName);
                                break;
                            case "order_amount":
                                transformedItem[newKey] = orderAmount + " " + "SAR";
                                break;
                            case "refunded_amount":
                                transformedItem[newKey] = refundedAmount + " " + "SAR";
                                break;
                            case "refund_reason":
                                transformedItem[newKey] = capitalizeFirstLetter(refundReason);
                                break;
                            case "payment_status":
                                transformedItem[newKey] = paymentStatus;
                                break;
                            case "refunded_at":
                                transformedItem[newKey] = refundedAt;
                                break;
                            case "business_date":
                                transformedItem[newKey] = formateDate(item.business_date);
                                break;
                            case "ordered_by":
                                transformedItem[newKey] = orderedBy;
                                break;
                            default:
                                // Handle any unexpected keys
                                console.warn(`Unexpected key in headerMapping: ${key}`);
                                transformedItem[newKey] = 'N/A';
                                break;
                        }
                    }
                }
                return transformedItem;
            });

            const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
            ws['!cols'] = getExcelColumnWidths(printData, Object.values(headerMapping));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'Refund.xlsx');
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
            setGlobalLoader(false);
        }).catch(error => {
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
            console.log("error ====> ", error);
            setGlobalLoader(false);
        })
    };

    const showReason = (row) => {
        const transaction = row?.transaction;

        if (transaction?.refund_reason_id) {
            return TrimText(capitalizeFirstLetter(transaction?.refundReason?.reason),20);
        } else if (transaction?.refund_reason) {
            return TrimText(capitalizeFirstLetter(transaction.refund_reason),20);
        }

        return 'N/A';
    };


    const generateOrderId = (orderId) => {
        let id = orderId;
        let countOfDigits = 0;
        while (id) {
            id = Math.floor(id / 10);
            countOfDigits += 1;
        }

        if (countOfDigits >= 4) {
            return orderId
        }
        let zerosCount = 4 - countOfDigits;
        let generatedZeros = '';
        while (zerosCount) {
            generatedZeros += '0';
            zerosCount -= 1;
        }
        return `${generatedZeros}${orderId}`;
    }

    function CopytoClipboard(text) {
        // Copy the text inside the text field
        navigator?.clipboard?.writeText(text);
        Swal.fire({
            customClass: 'swal-wide',
            icon: 'success',
            title: 'Copied to clipboard',
            showConfirmButton: false,
            timer: 2000,
            toast: true,
            position: 'top-right',
        });
    }

    const reportToZatca = (orderID) => {
        setLoaderNew(true);
        try {
            let formData = new FormData();
            formData.append("order_id", orderID);
            formData.append("report_type", 'refund');
            reportToZatcaAgain(formData)
                .then((response) => {
                    console.log("respone", response)
                    if (response?.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'success',
                            title: response?.data?.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        });
                        setLoaderNew(false);
                        setStatusUpdate(!statsUpdate)
                    }
                    else {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'error',
                            title: "Unable to send to the zatca",
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        });
                        setLoaderNew(false);
                    }
                })
                .catch((err) => {
                    console.error("Error in API call:", err);
                    setLoaderNew(false);
                });
        } catch (error) {
            console.error("Unexpected error:", error);
            setLoaderNew(false);
        }
    };

    const companyUser = JSON.parse(localStorage.getItem("company_user"))
    return (
        <>
            {globalLoader && <GlobalLoader/>}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Refund</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                    {/* {checkPermission('store_refund', 'add') ?
                        <button className="btn btn-primary ms-2" onClick={() => navigate(`/company/transaction/refund/configuration`)}>Configuration</button>
                        :''} */}
                        {companyUser?.platform_user_role?.slug=='company_admin' || companyUser?.platform_user_role?.slug=='system_admin' ?
                            <button className="btn btn-primary ms-2" onClick={() => navigate(`/company/transaction/refund/configuration`)}>Configuration</button>
                        :''}
                        <button onClick={handleExport} className="btn btn-primary ms-2">Export Refund</button>
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20'>
                        <div className='filter-header d-flex justify-content-between align-items-center'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="date-input">
                                    <CustomRangepicker defaultDateFilter={defaultDateFilter} GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                </div>
                                <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                            {loaderNew && (
                                    <div className="loader-overlay">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                <thead>
                                    <tr>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Order ID</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="order_id" />
                                            </div>
                                        </th>
                                        <th width="15%">
                                            <span>Order Mode</span>
                                        </th>
                                        <th width="15%">
                                            <span>Aggregator Name</span>
                                        </th>
                                        <th width="15%">
                                            <span>Ordered By</span>
                                        </th>
                                        <th width="15%">
                                            <span>Outlet Name</span>
                                        </th>
                                        <th width="15%">
                                            <span>Customer Name </span>
                                        </th>
                                        <th className="created_head" width="10%">
                                            <span>Refund Reason</span>
                                        </th>
                                        <th className="created_head" width="10%">
                                            <div className='sorting_column'>
                                                <span>Refunded Amount</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="refunded_amount" />
                                            </div>
                                        </th>
                                        {/* <th className="created_head" width="25%">
                                            <div className='sorting_column'>
                                                <span>Reason For Refund</span>
                                                
                                            </div>
                                        </th> */}
                                        <th className="created_head" width="10%">
                                            <span>Payment Status</span>
                                        </th>
                                        <th className="created_head" width="20%">
                                            <div className='sorting_column'>
                                                <span>Refunded At</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                            </div>
                                        </th>
                                        <th className="created_head" width="20%">
                                            <div >
                                                <span>Business Date</span>
                                            </div>
                                        </th>
                                        <th className="created_head" width="20%">
                                            <span>Zatca Status</span>
                                        </th>
                                        <th className="created_head text-end" width="5%">
                                            <span>Action</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={12}>
                                                <Loader />
                                            </td>
                                        </tr> : <>
                                            {list.length ? list.map((row, i) => (
                                                <tr>
                                                    <td>{`#order ${generateOrderId(row?.id)}`}</td>
                                                    <td>{row?.order_mode_configuration?.name ? capitalizeFirstLetter(removeHyphens(row?.order_mode_configuration.name)) : 'N/A'}</td>
                                                    <td>{row?.aggregators_configuration?.name ? capitalizeFirstLetter(removeHyphens(row?.aggregators_configuration.name)) : 'N/A'}</td>
                                                    <td>{row?.user ? `${capitalizeFirstLetter(row?.user?.first_name)} ${capitalizeFirstLetter(row?.user?.last_name)}` : 'N/A'}</td>
                                                    <td>{row?.outlet?.outlet_name ? capitalizeFirstLetter(row?.outlet.outlet_name) : 'N/A'}</td>
                                                    <td>{row?.customer?.customer_name ? row?.customer.customer_name : 'N/A'}</td>
                                                    <td>{row.transaction?.refundReason ? row?.transaction?.refundReason?.reason : "N/A"}</td>
                                                    <td>{row.transaction?.refunded_amount ? (row?.transaction?.refunded_amount + " " + "SAR") : "N/A"}</td>
                                                    {/* <td>{row.transaction?.refund_reason ? capitalizeFirstLetter(TrimText(row?.transaction?.refund_reason,25)) : "N/A"}</td> */}
                                                    {/* <td>{showReason(row)}</td> */}
                                                    {/* <td>{row.transaction?.payment_status ? capitalizeFirstLetter(row?.transaction?.payment_status) : "N/A"}</td> */}
                                                    <td>
                                                        {/* {
                                                            row?.transaction?.payment_status ? 
                                                                row?.transaction?.amount == row?.transaction?.refunded_amount ?
                                                                capitalizeFirstLetter(row?.transaction?.payment_status) : 
                                                                'Partial refunded'
                                                            : "N/A"
                                                        } */}
                                                        {
                                                            row?.transaction?.payment_status
                                                            ?
                                                                row?.transaction?.payment_status != 'refunded'
                                                                ?   capitalizeFirstLetter(row?.transaction?.payment_status)
                                                                :   row?.transaction?.refundReason?.type_of_refund == 'full' ? 'Refunded' : 'Partial Refunded'
                                                            : "N/A"
                                                        }
                                                    </td>
                                                    {/* <td>{row?.transaction?.refunded_time ? formateDate(row?.transaction?.refunded_time) : 'N/A' }</td> */}
                                                    <td >
                                                        {new Date(row?.transaction?.refunded_time).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true,
                                                        }).replace(',', '')}
                                                    </td>
                                                    <td>{row?.business_date ? formateDate(row?.business_date) : 'N/A' }</td>
                                                    <td>
                                                        {
                                                            !row?.transaction?.zatca_details
                                                                ? <span className='text-danger'>False</span>
                                                                : row?.transaction?.zatca_details?.success === false
                                                                    ? <button className="btn btn-danger btn-sm" onClick={() => { setShowZatcaDetailsModel(true); setZatcaModelData(row) }}>Error</button>
                                                                    : <button className="btn btn-primary btn-sm" onClick={() => { setShowZatcaDetailsModel(true); setZatcaModelData(row) }}>Cleared</button>
                                                        }
                                                    </td>
                                                    <td className='text-end'>
                                                        <div className="dropdown  d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>

                                                            <ul className="dropdown-menu">
                                                                {checkPermission('store_refund', 'view') ?
                                                                    <li><div className='dropdown-item' onClick={() => { viewFunction(row.id) }}><i className="ti ti-eye" aria-hidden="true"></i> View details</div></li>
                                                                    : ''}
                                                                <li><div className='dropdown-item' onClick={() => { printFunction(row.id) }}><i className="ti ti-printer" aria-hidden="true"></i> Print invoice</div></li>
                                                                {
                                                                    !row?.transaction?.zatca_details || row?.transaction?.zatca_details?.success == false ?
                                                                    <li><div className='dropdown-item' onClick={() => { reportToZatca(row?.id) }}> <i className="ti ti-receipt-refund sidemenu-icon"></i> Report to zatca again</div></li> :
                                                                    null
                                                                }
                                                              
                                                            </ul>
                                                                    
                                                            
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr>
                                                  <td colSpan={12} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No records</p>
                                                </td>
                                            </tr>}
                                        </>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "customer", path: "/company/transaction/refund/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
            </div>

            <Modal show={invoicePreview.open} onHide={() => setInvoicePreview({ open: false, image: '', order: null })} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title>Invoice Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ textAlign: 'center', maxHeight: '70vh', overflowY: 'auto', background: '#e9ecef' }}>
                    {invoicePreview.image &&
                        <img
                            src={invoicePreview.image}
                            alt="Invoice preview"
                            style={{ width: '300px', maxWidth: '100%', background: '#fff', boxShadow: '0 0 8px rgba(0,0,0,0.25)' }}
                        />
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setInvoicePreview({ open: false, image: '', order: null })}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleDownloadInvoice}>
                        <i className="ti ti-download me-1" aria-hidden="true"></i> Download PDF
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                size="lg"
                show={showZatcaDetailsModel}
                onHide={() => setShowZatcaDetailsModel(false)}
                backdrop={true}
                className="modal-height-auto"
            >
                <Modal.Header className="text-white">
                    <Modal.Title>{zatcaModelData?.transaction?.zatca_details?.success === false ? 'ZATCA Error Details' : 'ZATCA Details'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container overflow-auto" style={{ maxHeight: "70vh" }}>
                        {zatcaModelData?.transaction?.zatca_details?.success === false ? (
                            <>
                                {/* Error Header */}
                                <div className="mb-4">
                                    <h3 className="fw-bold text-danger">ZATCA Error Details</h3>
                                    <div className="row g-3">
                                        <div className="col-md-4">
                                            <p>
                                                <strong>Order Date:</strong>{" "}
                                                <span className="text-secondary">{formateDate(zatcaModelData?.transaction?.zatca_details?.order_created_at || zatcaModelData?.transaction?.created_at)}</span>
                                            </p>
                                        </div>
                                        <div className="col-md-4">
                                            <p>
                                                <strong>Transaction Date:</strong>{" "}
                                                <span className="text-secondary">{formateDate(zatcaModelData?.transaction?.zatca_details?.order_transaction_at || zatcaModelData?.transaction?.customer_order?.created_at)}</span>
                                            </p>
                                        </div>
                                        <div className="col-md-4">
                                            <p>
                                                <strong>HTTP Status:</strong>{" "}
                                                <span className="text-danger">{zatcaModelData?.transaction?.zatca_details?.status || 'N/A'}</span>
                                            </p>
                                        </div>
                                        <div className="col-md-4">
                                            <p>
                                                <strong>ZATCA Status:</strong>{" "}
                                                <span className="text-danger">{zatcaModelData?.transaction?.zatca_details?.message?.status || 'ERROR'}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-4" />
                                {/* Error Messages */}
                                <div className="mb-4">
                                    <h3 className="fw-bold">Error Messages</h3>
                                    {zatcaModelData?.transaction?.zatca_details?.message?.errorMessages?.length > 0 ? (
                                        zatcaModelData.transaction.zatca_details.message.errorMessages.map((err, i) => (
                                            <div key={i} className="bg-light border border-danger rounded p-3 mb-3">
                                                <div className="row g-2">
                                                    <div className="col-md-6">
                                                        <p className="mb-1"><strong>Code:</strong> <span className="text-danger">{err.code || 'N/A'}</span></p>
                                                        <p className="mb-1"><strong>Type:</strong> <span className="text-secondary">{err.type || 'N/A'}</span></p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <p className="mb-1"><strong>Status:</strong> <span className="text-danger">{err.status || 'N/A'}</span></p>
                                                        <p className="mb-1"><strong>Category:</strong> <span className="text-secondary">{err.category || 'N/A'}</span></p>
                                                    </div>
                                                    <div className="col-12">
                                                        <p className="mb-0"><strong>Message:</strong> <span className="text-secondary">{err.message || 'N/A'}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-secondary">No error messages available.</p>
                                    )}
                                </div>
                                {/* Warning Messages */}
                                {zatcaModelData?.transaction?.zatca_details?.message?.warningMessages?.length > 0 && (
                                    <>
                                        <hr className="my-4" />
                                        <div className="mb-4">
                                            <h3 className="fw-bold">Warning Messages</h3>
                                            {zatcaModelData.transaction.zatca_details.message.warningMessages.map((warn, i) => (
                                                <div key={i} className="bg-light border border-warning rounded p-3 mb-3">
                                                    <p className="mb-1"><strong>Code:</strong> <span className="text-warning">{warn.code || 'N/A'}</span></p>
                                                    <p className="mb-1"><strong>Category:</strong> <span className="text-secondary">{warn.category || 'N/A'}</span></p>
                                                    <p className="mb-0"><strong>Message:</strong> <span className="text-secondary">{warn.message || 'N/A'}</span></p>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                                {/* Info Messages */}
                                {zatcaModelData?.transaction?.zatca_details?.message?.infoMessages?.length > 0 && (
                                    <>
                                        <hr className="my-4" />
                                        <div className="mb-4">
                                            <h3 className="fw-bold">Info Messages</h3>
                                            {zatcaModelData.transaction.zatca_details.message.infoMessages.map((info, i) => (
                                                <div key={i} className="bg-light border rounded p-3 mb-3">
                                                    <p className="mb-1"><strong>Code:</strong> <span className="text-secondary">{info.code || 'N/A'}</span></p>
                                                    <p className="mb-0"><strong>Message:</strong> <span className="text-secondary">{info.message || 'N/A'}</span></p>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                {/* Header Details */}
                                <div className="mb-4">
                                    <h3 className="fw-bold">Header Details</h3>
                                    <div className="row g-3">
                                        <div className="col-md-4">
                                            <p>
                                                <strong>Order Date:</strong>{" "}
                                                <span className="text-secondary">
                                                    {formateDate(zatcaModelData?.transaction?.zatca_details?.order_created_at || zatcaModelData?.transaction?.created_at)}
                                                </span>
                                            </p>
                                        </div>
                                        <div className="col-md-4">
                                            <p>
                                                <strong>Transaction Date:</strong>{" "}
                                                <span className="text-secondary">
                                                    {formateDate(zatcaModelData?.transaction?.zatca_details?.order_transaction_at || zatcaModelData?.transaction?.customer_order?.created_at)}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-4" />

                                {/* Document Type and Status */}
                                <div className="mb-4">
                                    <h3 className="fw-bold">Document Type & Status</h3>
                                    <p>
                                        <strong>Document Type:</strong>{" "}
                                        <span className="text-secondary">Sales Invoice</span>
                                    </p>
                                    <p>
                                        <strong>ZATCA Status:</strong>{" "}
                                        <span className="text-secondary">Cleared</span>
                                    </p>
                                </div>
                                <hr className="my-4" />

                                {/* QR Code and Validation Results */}
                                <div className="mb-4">
                                    <h3 className="fw-bold">QR Code & Validation Results</h3>
                                    <div className="row g-4 align-items-center">
                                        <div className="col-md-6">
                                            <h5 className="fw-semibold">Validation Results</h5>
                                            <div className="bg-light p-3 rounded shadow-sm h-100 d-flex flex-column justify-content-center" style={{ minHeight: "200px" }}>
                                                <p><strong>Status:</strong> <span className="text-secondary">202 Accepted</span></p>
                                                <p><strong>Validation Result:</strong> <span className="text-secondary">Accepted</span></p>
                                                <p>
                                                    <strong>InfoMessages:</strong>{" "}
                                                    <span className="text-secondary">
                                                        {zatcaModelData?.transaction?.zatca_details?.validation_results?.infoMessages?.[0]?.message || "N/A"}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-6 text-center">
                                            <h5 className="fw-semibold">QR Code</h5>
                                            <div className="bg-light p-4 rounded shadow-sm h-100 d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                                                <QRCode
                                                    size={256}
                                                    style={{ height: "auto", maxWidth: "50%", width: "50%" }}
                                                    value={zatcaModelData?.transaction?.zatca_details?.qr || 'Sample Qr'}
                                                    viewBox={`0 0 256 256`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Invoice XML */}
                                <div className="mb-4">
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <h3 className="fw-bold text-dark">Invoice XML</h3>
                                        <button type="button" className="btn btn-sm btn-main-primary ripple ms-3" onClick={() => { CopytoClipboard(zatcaModelData?.transaction?.zatca_details?.invoice_xml) }}>
                                            <i className="fa fa-clone" aria-hidden="true"></i>
                                            <span className="d-none d-sm-inline"> Copy</span>
                                        </button>
                                    </div>
                                    <div className="row g-4 align-items-center">
                                        <div className="col-md-12 text-center">
                                            <div className="bg-light p-4 rounded shadow-sm h-100 d-flex justify-content-center align-items-center" style={{ minHeight: "250" }}>
                                                <textarea className="form-control" rows={20} style={{ width: "100%", minHeight: "300px", resize: "vertical" }} value={zatcaModelData?.transaction?.zatca_details?.invoice_xml || ''} readOnly />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowZatcaDetailsModel(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <ToastContainer
                position="top-right"
                hideProgressBar={false}
                autoClose={true | 1000}
                newestOnTop={true}
                closeOnClick={false}
                draggable={false}
                rtl={false}
            />

        </>
    );
}

export default RefundList